'use client';

import GoogleAnalytics from '@/components/GoogleAnalytics';

interface GoogleAnalyticsWrapperProps {
  measurementId: string;
}

const GoogleAnalyticsWrapper = ({
  measurementId,
}: GoogleAnalyticsWrapperProps) => {
  return <GoogleAnalytics measurementId={measurementId} />;
};

export default GoogleAnalyticsWrapper;
